var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var ReviewConfigurationService = /** @class */ (function (_super) {
            __extends(ReviewConfigurationService, _super);
            function ReviewConfigurationService(injectedBreeze, $q, $http) {
                var _this = _super.call(this, injectedBreeze, $q) || this;
                _this.$http = $http;
                return _this;
            }
            ReviewConfigurationService.prototype.createReviewConfiguration = function () {
                var config = this.createNewEntity("ReviewConfiguration");
                config.uniqueIdentifier = services.UtilityService.generateGuidComb();
                return config;
            };
            ReviewConfigurationService.prototype.createReviewReminder = function () {
                return this.createNewEntity("ReviewReminder");
            };
            ReviewConfigurationService.prototype.getExtensibleUserRepositories = function () {
                var d = this.$q.defer();
                this.$http.get('./api/ExtensibleComponent/GetExternalUserRepositories').then(function (result) {
                    d.resolve(result.data);
                });
                return d.promise;
            };
            ReviewConfigurationService.prototype.getReviewConfigurations = function (processId) {
                var query = this.breezeModule.EntityQuery
                    .from("ReviewConfigurationsLazy");
                if (processId) {
                    query = query.where('processConfiguration_id', '==', processId);
                }
                else {
                    query = query.where('processConfiguration_id', '==', null);
                }
                query = query.expand("securityMatrix, " +
                    "reviewReminders, " +
                    "codeGroup.codes, " +
                    "systemReviewGroup, " +
                    "documentConfiguration, " +
                    "canRemoveSecurityMatrix, " +
                    "commentThreadConfiguration.canCommentSecurityMatrix, " +
                    "commentThreadConfiguration.canDeleteSecurityMatrix, " +
                    "commentThreadConfiguration.canAddDocumentSecurityMatrix, " +
                    "commentThreadConfiguration.documentConfiguration.canDownloadSecureDocumentSecurityMatrix, " +
                    "commentThreadConfiguration.documentConfiguration.canSecureDocumentSecurityMatrix, " +
                    "commentThreadConfiguration.documentConfiguration.myAvailableDocumentTypes.mySystemCode, " +
                    "commentThreadConfiguration.canViewDeletedCommentsSecurityMatrix, " +
                    "commentThreadConfiguration.commentEmailConfiguration," +
                    "commentThreadConfiguration.canCommentSecurityMatrix").orderBy("name");
                return this.executeQuery(query);
            };
            return ReviewConfigurationService;
        }(services.DataService));
        services.ReviewConfigurationService = ReviewConfigurationService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('ReviewConfigurationService', ['breeze', '$q', '$http']);
